import { render, staticRenderFns } from "./MisCapacitaciones.vue?vue&type=template&id=6b030c84&scoped=true"
import script from "./MisCapacitaciones.vue?vue&type=script&lang=js"
export * from "./MisCapacitaciones.vue?vue&type=script&lang=js"
import style0 from "./MisCapacitaciones.vue?vue&type=style&index=0&id=6b030c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b030c84",
  null
  
)

export default component.exports